import styled from 'styled-components';

import { ThemeProp } from '../../../theme/Themes';

export const SCROLLABLE_CARD_MIN_WIDTH = '60rem';

export const Container = styled.div`
  display: flex;
  background: ${(props: ThemeProp) => props.theme.colors.greyscale.c900};
  padding: 1.25rem;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  justify-content: space-between;
  min-width: ${SCROLLABLE_CARD_MIN_WIDTH};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.secondary};
  height: 3.5rem;
`;
